'use strict'

import {normalize} from 'normalizr'

const SET_PLATE_LIST = 'SET_PLATE_LIST'

const SET_PLATE_FILTER = 'SET_PLATE_FILTER'

const SET_PLATE = 'SET_PLATE'

const CREATE_PLATE = 'CREATE_PLATE'
const UPDATE_PLATE = 'UPDATE_PLATE'
const DELETE_PLATES = 'DELETE_PLATES'

const PLATE_SET_WELLS = 'PLATE_SET_WELLS'

const PLATE_SET_PROJECT = 'PLATE_SET_PROJECT'

// отложенная загрузка данных спектра лунки
const LOADING_WELL_SPECTRA = 'LOADING_WELL_SPECTRA'
export const LOAD_WELL_SPECTRA = 'LOAD_WELL_SPECTRA'

const LOADING_WELL_PROBE_DATA = 'LOADING_WELL_PROBE_DATA'
export const LOAD_WELL_PROBE_DATA = 'LOAD_WELL_PROBE_DATA'

const LOADING_WELL_TARGET_DATA = 'LOADING_WELL_TARGET_DATA'
export const LOAD_WELL_TARGET_DATA = 'LOAD_WELL_TARGET_DATA'

export const PURGE_WELL_DATA = 'PURGE_WELL_DATA'


import format from 'string-format'
import api from '../../api'
import {Plate} from "../../models"

const initialState = {
	plate_list: [], // список маленьких объектов
	plates: {}, // словарь по ключу id маленьких объектов

	plate_filter: {
		name_txt: "",
		extra: false,
		failed: -1,
		ready: -1,
	},

	plate: Plate.empty_plate,
}

const actions = {
	fetchPlateList: function ({commit, getters, dispatch}, {project_id}) {
		console.debug("store.plate.fetchPlateList()")

		return Promise.all([
			dispatch('plate/list_plate', {project_id}, {root: true})
		])
			.then(function ([
				list_plate_promise]) {

				console.debug("store.plate.fetchPlateList() then")
			})
	},

	list_plate: function ({commit}, {project_id}) {
		console.debug("store.plate.list_plate() ")

		return api.plate.plate_list(project_id)
			.then(function (response) {
				commit(SET_PLATE_LIST, response.data)
				return true
			})
			.catch(function (error) {
				commit(SET_PLATE_LIST, [])
				throw error
			})
	},

	set_filter: function ({commit}, {filter}) {
		commit(SET_PLATE_FILTER, filter)
	},

	fetchPlate: function ({commit, getters, dispatch, rootState}, {plate_id}) {

		if (plate_id) {
			return api.plate.plate_get(plate_id)
				.then(function (response) {
					const plate = new Plate(response.data, rootState)
					commit(SET_PLATE, plate)
				})
				.catch(function (error) {
					commit(SET_PLATE, Plate.empty_plate)
					throw error
				})

		} else {
			commit(SET_PLATE, Plate.empty_plate)
		}
	},

	create_plate: function ({commit}, {plate, details = false}) {
		console.debug(format(
			"store.modules.plate.create_plate( , details: {details} )",
			{details: details,}))

		return api.plate.plate_create(plate, details)
			.then(function (response) {
				commit(CREATE_PLATE, response.data)
			})
	},

	update_plate: function ({commit}, {plate, details = false}) {
		console.debug(format(
			"store.modules.plate.update_plate( ,details: {0} )\n" + "  plate:{1}",
			details, JSON.stringify(plate)))

		return api.plate.plate_update(plate, details)
			.then(function (response) {
				commit(UPDATE_PLATE, response.data)
			})
	},

	delete_plates: function ({commit}, plate_id_list) {
		console.debug(format(
			"store.modules.plate.delete_plates( {0} )",
			JSON.stringify(plate_id_list)))

		return api.plate.plates_delete(plate_id_list)
			.then(function (response) {
				const plate_list_deleted = response.data
				commit(DELETE_PLATES, plate_list_deleted)

				return plate_list_deleted
			})
	},

	load_well_spectra: function ({commit}, {well}) {
		commit(LOADING_WELL_SPECTRA, well)

		return api.plate.load_well_spectra(well.plate.id, well.well_num)
			.then(function (response) {
				commit(LOAD_WELL_SPECTRA, {well, spectra: response.data})
			})
			.catch(function (error) {
				commit(LOAD_WELL_SPECTRA, {well, spectra: []})
				throw error
			})
	},

	load_well_probe_data: function ({commit}, {well}) {
		commit(LOADING_WELL_PROBE_DATA, well)

		return api.plate.load_well_probe_data(well.plate.id, well.well_num)
			.then(function (response) {
				commit(LOAD_WELL_PROBE_DATA, {well, probe_data: response.data})
			})
			.catch(function (error) {
				// если задать null, то в обработчике мутации
				// обычно снова случится запрос данных
				commit(LOAD_WELL_PROBE_DATA, {well, probe_data: {}})
			})
	},

	purge_well_data: function ({commit, dispatch},) {
		commit(PURGE_WELL_DATA)
		return true
	},


	/**
	 * set props for some wells of plate
	 * @param commit
	 * @param dispatch
	 * @param rootState
	 * @param plate
	 * @param well_nums
	 * @param props
	 * @returns {Promise<AxiosResponse<any>>}
	 */
	update_wells: function ({commit, dispatch, rootState}, {plate, well_nums, props}) {
		return api.plate.update_wells(plate.id, well_nums, props)
			.then(function (response) {
				// здесь получим объекты лунок, свойства которых обновили,
				// надо обновить лунки в объекте планшеты
				commit(PLATE_SET_WELLS, response.data)
				return true
			})
			.catch(function (error) {
				// если случилась ошибка, то данные планшеты надо перезагрузить целиком
				dispatch('fetchPlate', {plate_id: plate.id})
				throw error
			})
	}
}

const mutations = {
	[SET_PLATE_LIST](state, data) {
		console.debug("store.plate.mutations.SET_PLATE_LIST()")

		// для элемента списка планшет нет специального класса
		// Plate - класс планшеты подробный с лунками
		state.plate_list = data
		state.plates = Object.assign(
			{},
			...data.map((p) => ({[p.id]: p})))
	},

	[SET_PLATE_FILTER](state, data) {
		// переданный объект не надо помещать в store,
		// иначе потом его нельзя будет менять вне мутаций
		// поэтому копируем значения свойств
		for (let key in state.plate_filter) {
			state.plate_filter[key] = data[key]
		}
	},

	/**
	 * Set current plate of application
	 * @param state
	 * @param plate
	 */
	[SET_PLATE](state, plate) {
		state.plate = plate
	},

	[PLATE_SET_PROJECT](state, {plate, project}) {
		plate.project = project
	},

	[CREATE_PLATE](state, obj) {
		state.plate_list.push(obj)
		state.plates[obj.id] = obj
	},

	/**
	 * Update Plate props (name, file, notes etc.)
	 * @param state
	 * @param obj
	 */
	[UPDATE_PLATE](state, obj) {
		// чтобы не заменять объект в списках
		// state.plate_list и state.plates
		// обновим значения полей
		const tgt = state.plates[obj.id]
		for (let key in tgt) {
			tgt[key] = obj[key]
		}
	},

	[DELETE_PLATES](state, plate_id_list) {
		for (const plate_id of plate_id_list) {
			if (plate_id in state.plates) {
				const plate = state.plates[plate_id]
				delete state.plates[plate_id]

				const plate_idx = state.plate_list.indexOf(plate)
				if (plate_idx > -1) {
					state.plate_list.splice(plate_idx, 1)
				}
			}
		}
	},

	/**
	 * установить данные планшеты
	 * @param state
	 * @param data
	 */
	[PLATE_SET_WELLS](state, data) {
		if (state.plate.id === data.plate_id) {
			state.plate.update(data)
		}
	},

	[LOADING_WELL_SPECTRA](state, well) {
		well._spectra_loading = true
	},

	[LOAD_WELL_SPECTRA](state, {well, spectra}) {
		console.debug(format("LOAD_WELL_SPECTRA( #{0} )", well.well_num))
		well._spectra = spectra
		well._spectra_loading = false
	},

	[LOADING_WELL_PROBE_DATA](state, well) {
		well._probe_data_loading = true
	},

	[LOAD_WELL_PROBE_DATA](state, {well, probe_data}) {
		well._probe_data = probe_data
		well._probe_data_loading = false
	},

	[PURGE_WELL_DATA](state) {
		let k = 21
		for (let well_num in state.plate.wells) {
			const well = state.plate.wells[well_num]
			well._spectra = null
			well._probe_data = null
		}
	},
}

const getters = {
	plate_list: function (state) {
		return state.plate_list
	},

	plates: function (state) {
		return state.plates
	},

	plate_filter: function (state) {
		console.debug("store.plate.getters.plate_filter()")
		return state.plate_filter
	},

	plate: function (state) {
		return state.plate
	},

}

export default {
	namespaced: true,

	state: initialState,

	actions,
	mutations,
	getters,
}